/**
 * Use Case: Deletar Produto
 * Responsabilidade: Orquestra a exclusão de um produto
 * Princípios: Single Responsibility, Dependency Inversion
 */

import { IProductRepository } from '../../../domain/repositories/IProductRepository';
import { ValidationError } from '../../../core/errors/DomainErrors';

export interface DeleteProductDTO {
    id: string;
}

export class DeleteProductUseCase {
    constructor(private readonly productRepository: IProductRepository) { }

    async execute(dto: DeleteProductDTO): Promise<void> {
        // Busca produto para validar se existe
        const product = await this.productRepository.findById(dto.id);

        if (!product) {
            throw new ValidationError('Produto não encontrado');
        }

        // Valida se pode ser deletado (regra de negócio)
        if (!product.canBeDeleted()) {
            throw new ValidationError('Este produto não pode ser deletado');
        }

        // Deleta produto
        await this.productRepository.delete(dto.id);
    }
}
